import { Card } from "@/components/ui/card";
import { Body, Superscript } from "@hypercard/web-components";
import { ArrowUpRight } from "@phosphor-icons/react";

type Props = {
  headerText: string;
  primaryText: string;
  percentageChange?: string;
  icon?: React.ReactNode;
  subText: string;
};

export const StatCard = ({
  headerText,
  primaryText,
  percentageChange,
  subText,
  icon,
}: Props) => {
  return (
    <Card className="p-4">
      <Superscript size="md" className="text-[#676767]">
        {headerText}
      </Superscript>
      <div className="mt-4 flex items-center space-x-3">
        {icon}
        <Body size="lg" weight="regular">
          {primaryText}
        </Body>
      </div>
      <div className="mt-2 flex items-center space-x-2">
        {percentageChange && (
          <div className="flex items-center space-x-1 rounded-full bg-[#54C186]/40 px-1.5 py-1 text-[#54C186]">
            <ArrowUpRight size={16} weight="bold" />
            <Body size="xs" weight="regular">
              {percentageChange}
            </Body>
          </div>
        )}
        <Body size="xs" weight="regular" className="text-[#676767]">
          {subText}
        </Body>
      </div>
    </Card>
  );
};
